import {useEffect, useState } from 'react';
import Select from 'react-select';


const CircuitBenchmarkForm = ({ circuit_id, circuitFiles, onError, onSubmit, disabled }) => {
    const [inputFiles, setInputFiles] = useState([]);
    const [curves, setCurves] = useState([]);
    const [reps, setReps] = useState('10');
    const [machines, setMachines] = useState([]);
    const [backends, setBackends] = useState([]);
    const [maxWorkers, setMaxWorkers] = useState(1);
    const [loading, setLoading] = useState(false);

    const [inputFileOptions, setInputFileOptions] = useState([]);

    useEffect(() => {
        setInputFileOptions(
            circuitFiles
                .filter((file) => { return file.extension === 'json' })
                .map((file) => {
                    const fullname = file.name + '.' + file.extension;
                    return { value: file.id, label: fullname };
                }));
    }, [circuitFiles])

    const curveOptions = [
        { value: 'BN254', label: 'BN254' },
        { value: 'BLS12-381', label: 'BLS12-381' },
        { value: 'Pasta', label: 'Pasta' }
    ];  // get it from backend ? 

    const machineTypes = ["t4g.medium", "c6g.large", "r6g.xlarge"];  // get it from DB
    const AvailableBackends = ["Groth16", "Plonk"]; // get it from DB

    const handleSubmit = async (e) => {
        e.preventDefault();
        console.log(disabled);
        if(disabled){
            window.alert("Unsaved changed!");
            onError("Unsaved changes!");
        }
        setLoading(true);
        console.log({
            circuitId: circuit_id,
            inputFiles: inputFiles.map(f => f.value),
            curves: curves.map(c => c.value),
            reps,
            machines: machines,
            parallelism: maxWorkers
        });

        const resp = await onSubmit({
            inputFiles: inputFiles.map(f => f.label),
            curves: curves.map(c => c.value),
            reps,
            machines: machines,
            backends: backends,
            parallelism: maxWorkers
        });


        setCurves([]);
        setInputFiles([]);
        setMachines([]);
        setBackends([])
        setMaxWorkers(1);
        setReps(10);
        if(resp) setLoading(false);
    };

    const toggleBackend = (type) => {
        if (backends.includes(type)) {
            setBackends((prev) => prev.filter((b) => b != type));
        }
        else {
            setBackends((prev) => [type, ...prev]);
        }
    };

    const toggleMachine = (type) => {
        if (machines.includes(type)) {
            setMachines((prev) => prev.filter((b) => b != type));
        }else{
            setMachines((prev) => [...prev, type]);
        }
    };

    useEffect(() => {
        // setMachineType(machineTypes[0]);
    }, []);

    return (
        <div className='mb-3'>
            <h1 className='mx-0 has-text-centered'>Submit New Benchmark</h1>
            <form onSubmit={handleSubmit} className="" >
                {/* Input Files */}
                <div className="field">
                    <label className="label is-small">Input files</label>
                    <div className="control">
                        <Select
                            isMulti
                            options={inputFileOptions}
                            value={inputFiles}
                            onChange={setInputFiles}
                            classNamePrefix="select"
                            placeholder="Select input files..."
                            required
                        />
                    </div>
                </div>

                {/* Curve */}
                <div className="field">
                    <label className="label is-small">Curve</label>
                    <div className="control">
                        <Select
                            isMulti
                            options={curveOptions}
                            value={curves}
                            onChange={setCurves}
                            classNamePrefix="select"
                            placeholder="Select curves..."
                            required
                        />
                    </div>
                </div>

                {/* Backend */}
                <div className="field">
                    <label className="label is-small">Proving Backend</label>
                    <div className="control">
                        <div className="tags">
                            {AvailableBackends.map((type) => (
                                <span
                                    key={type}
                                    className={`tag is-normal is-clickable is-radiusless ${backends.includes(type) ? "is-danger" : "is-light is-hoverable"
                                        }`}
                                    onClick={() => toggleBackend(type)}
                                >
                                    {type}
                                    {backends.includes(type) && <button className="delete is-small"></button>}
                                </span>
                            ))}
                        </div>
                    </div>
                </div>

                {/* Parallel reps */}
                <div className="field mx-auto">
                    <label className="label is-small">Repetition</label>
                    <div className="control">
                        {[1, 10, 50, 100, 500].map((w) => (
                            <label key={w} className="radio mr-4">
                                <input
                                    type="radio"
                                    name="reps"
                                    value={w}
                                    checked={reps === String(w)}
                                    onChange={(e) => setReps(e.target.value)}
                                />{' '}
                                {w}
                            </label>
                        ))}
                    </div>
                </div>


                {/* Machine Type */}
                <div className="field">
                    <label className="label is-small">Machine type</label>
                    <div className="control">
                        <div className="tags">
                            {machineTypes.map((type) => (
                                <span
                                    key={type}
                                    className={`tag is-normal is-clickable is-radiusless ${machines.includes(type) ? "is-primary" : "is-light is-hoverable"
                                        }`}
                                    onClick={() => toggleMachine(type)}
                                >
                                    {type}
                                </span>
                            ))}
                        </div>
                    </div>
                </div>

                {/* Max Parallel Workers */}
                <div className="field">
                    <label className="label is-small">Maximum Parallel Workers</label>
                    <div className='control'>
                        <input
                            type="number"
                            className="input is-normal"
                            value={maxWorkers}
                            min="1"
                            max="16"
                            onChange={(e) => setMaxWorkers(Number(e.target.value))}
                        />
                    </div>
                </div>

                {/* Submit Button */}
                <div className="field mt-5 mb-5">
                    <div className="control has-text-centered">
                        <button className={`button is-centered is-link ${loading && 'is-loading'} `} type="submit" disabled={loading || disabled}>
                            Submit Benchmark Request
                        </button>
                    </div>
                </div>
                {loading && <progress class="progress" max="100"></progress>}
            </form>
        </div>
    );
}

export default CircuitBenchmarkForm;